import { root, id } from './players';

export const players = {
  ...root,
  id,
};
